import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[mdTableHover]',
})
export class TableHoverDirective implements AfterViewInit, OnChanges {
  @Input() mdTableHover: any;

  @HostListener('window:resize')
  windowResize() {
    this.tableStateHoverUpdate();
  }

  constructor(private tableRef: ElementRef, private zone: NgZone) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.mdTableHover && !changes.mdTableHover.firstChange) {
      this.init();
    }
  }

  ngAfterViewInit() {
    this.init();
  }

  init() {
    setTimeout(() => this.zone.runOutsideAngular(() => this.tableStateHoverInit()));
  }

  tableStateHoverInit() {
    const $table = $(this.tableRef.nativeElement);
    const $notCls = ':hidden, .is-hover-state, .row-bg, .items-table__row-transparent';
    const $notFooter = '.row-bg:not([data-parent])';
    const $rowBg = '<span class="row-type__bg"></span>';
    const $spacers = $table.find('.items-table__spacer');

    $spacers.each(function (index) {
      const $spacer = $(this);
      const $first = $spacer.prevAll().not($notCls).children().first();
      const $next = $spacer.next().not($notCls).children().first();

      if (index === 0) {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        if (!$first.children('.row-type__bg').length) {
          $first.css('position', 'static').prepend($rowBg);
        }
        $spacer.closest('table').css('position', 'relative');
      }

      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (!$spacer.nextAll($notFooter).first().length) {
        if (!$next.children('.row-type__bg').length) {
          $next.addClass('position-static').prepend($rowBg);
        }
      }
    });

    setTimeout(this.tableStateHover, 100);
  }

  tableStateHover(update: boolean) {
    const $elem = $('.row-type__bg');

    $elem.each(function (index, el) {
      const $el = $(el);
      const $row = $el.parent().parent();
      const $wrap = $el.parent();
      const $table = $el.closest('table');
      // @ts-expect-error
      const $tableTop = $table.offset().top;
      const $isState = 'is-hover-state';

      if (update) {
        resizeBg($el.not(':hidden'), $wrap, $tableTop);
        return;
      }

      if (!$row.hasClass($isState)) {
        // @ts-expect-error
        $el.css({
          height: $wrap.outerHeight(),
          // @ts-expect-error
          top: $wrap.offset().top - $tableTop,
          'border-left': () => {
            const value = $wrap.css('border-left');
            $wrap.css('border-left-color', 'transparent');
            return value;
          },
          'border-top': () => {
            const td = $row.find('td');
            const value = td.css('border-top');
            td.css('border-top-color', 'transparent');
            return value;
          },
          'background-color': () => {
            const value = $row.css('background-color');
            $row.css('background-color', 'transparent');
            return value;
          },
          'box-shadow': () => {
            const value = $row.css('box-shadow');
            $row.css('box-shadow', 'none');
            return value;
          },
        });
      } else {
        resizeBg($el, $wrap, $tableTop);
      }

      $table.on('input', 'input, textarea', function () {
        resizeBg($el, $wrap, $tableTop);
      });

      $row.addClass($isState);
    });

    function resizeBg(
      el: JQuery<HTMLElement>,
      $wrap: JQuery<HTMLElement>,
      $tableTop: number,
    ) {
      // @ts-expect-error
      el.css({
        height: $wrap.outerHeight(),
        // @ts-expect-error
        top: $wrap.offset().top - $tableTop,
      });
    }
  }

  tableStateHoverUpdate() {
    this.tableStateHover(true);
  }
}
